import React from "react";
import { StorageSource } from "../types";

export const StorageSourceContext = React.createContext<StorageSource>({} as StorageSource);
